import { createSlice } from "@reduxjs/toolkit";

import { logOutLocal } from "@shared/api/reduxToolkit/auth";
import { authApi, userApi } from "@shared/api/rtkQuery";

const initialState = {
  accountMembershipId: null,
  isLoadingUser: false,
  user: {
    id: null,
    employeeId: null,
    employeeEntryDate: null,
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    birthDate: null,
    companyId: null,
    companyName: "",
    companyUser: false,
    defaultBenefitConfig: "",
    defaultBenefitConfigId: null,
    balances: [],
    companyUsers: [],
    debitCard: {
      id: null,
      type: "",
      cardImageUrl: "",
      cardMaskedNumber: "",
      cardExpDate: "",
      cardStatus: "",
    },
    debitCards: [],
  },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(logOutLocal, (state) => {
        Object.assign(state, initialState);
      })

      .addMatcher(
        userApi.endpoints.getCurrentUser.matchPending,
        (state) => {
          state.isLoadingUser = true;
        },
      )

      .addMatcher(
        userApi.endpoints.getCurrentUser.matchFulfilled,
        (state, action) => {
          state.user = action.payload;
          state.accountMembershipId = action.payload.id;
          state.isLoadingUser = false;
        },
      )
      .addMatcher(
        userApi.endpoints.getCurrentUser.matchRejected,
        (state) => {
          state.isLoadingUser = false;
        },
      )

      .addMatcher(authApi.endpoints.logOut.matchFulfilled, (state) => {
        Object.assign(state, initialState);
      });
  },
});

export const userReducer = userSlice.reducer;
